import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

export interface HighlighterDriver<T> extends BaseDriver {
  getElement: () => T;
  html: () => string;
}
